import type { RouteComponent, RouteRecordRaw } from "vue-router";

import { AppRoute, AppRouteNames } from "./constants";

import Login from "@/views/Login.vue";
import ResetPassword from "@/views/ResetPassword.vue";
import NetworkError from "@/views/NetworkError.vue";
import LocalDevNetworkError from "@/views/LocalDevNetworkError.vue";
import PreviewShare from "@/views/PreviewShare.vue";

export const publicRoutes: RouteRecordRaw[] = [
    {
        path: AppRoute.LOGIN,
        name: AppRouteNames.LOGIN,
        component: Login as RouteComponent,
        meta: { theme: "login" }
    },
    {
        path: AppRoute.RESET_PASSWORD,
        name: AppRouteNames.RESET_PASSWORD,
        component: ResetPassword as RouteComponent,
        meta: { theme: "login" }
    },
    {
        path: AppRoute.NETWORK_ERROR,
        name: AppRouteNames.NETWORK_ERROR,
        component: NetworkError as RouteComponent
    },
    {
        path: AppRoute.LOCAL_DEV_NETWORK_ERROR,
        name: AppRouteNames.LOCAL_DEV_NETWORK_ERROR,
        component: LocalDevNetworkError as RouteComponent
    },
    {
        path: AppRoute.PREVIEW,
        name: AppRouteNames.PREVIEW,
        component: PreviewShare as RouteComponent,
        meta: { hideHeader: true }
    }
] as const;
